export default __webpack_public_path__ + "static/media/sch7_w1024.50e318d2.jpg";